import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  selectActiveAgentsCount,
  selectInactiveAgentsCount,
  selectOverdueAgentsCount,
  selectWebinarCompletedPercent,
  selectMobileEnabledPercent
} from 'broker/selectors/broker_agents_stats'

import { selectAccountLoading } from 'broker/selectors/account'

import { wholeInteger, wholePercent, formatOrDash } from 'broker/util/helper'

import Card from 'broker/views/components/Card'
import RawCardSection from 'broker/views/components/CardSection'
import CardFlexingContentRow from 'broker/views/components/CardFlexingContentRow'
import RawCardDataPoint from 'broker/views/components/CardDataPoint'
import CardRow from 'broker/views/components/CardRow'

const CardDataPoint = connect(createStructuredSelector({
  loading: selectAccountLoading
}))(RawCardDataPoint)

const CardSection = connect(createStructuredSelector({
  loading: selectAccountLoading
}))(RawCardSection)

class BrokerAgentStatsCard extends Component {
  render() {
    const {
      activeAgentsCount,
      inactiveAgentsCount,
      overdueAgentsCount,
      webinarCompletedPercent,
      mobileEnabledPercent
    } = this.props

    return (
      <Card>
        <CardSection title="Agent Stats" nopad>
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Active Agents"
                value={formatOrDash(activeAgentsCount, wholeInteger)}
                small
              />
              <CardDataPoint
                title="Inactive Agents"
                value={formatOrDash(inactiveAgentsCount, wholeInteger)}
                small
              />
            </CardFlexingContentRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Overdue Agents" // TODO: this needs to be snoozed agents
                value={formatOrDash(overdueAgentsCount, wholeInteger)}
                small
              />
              <CardDataPoint
                title="Completed Training"
                value={formatOrDash(webinarCompletedPercent, wholePercent, { suffix: '%' })}
                small
              />
            </CardFlexingContentRow>
          </CardRow>
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Using Mobile App"
                value={formatOrDash(mobileEnabledPercent, wholePercent, { suffix: '%' })}
                small
              />
            </CardFlexingContentRow>
          </CardRow>
        </CardSection>
      </Card>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  activeAgentsCount: selectActiveAgentsCount,
  inactiveAgentsCount: selectInactiveAgentsCount,
  overdueAgentsCount: selectOverdueAgentsCount,
  webinarCompletedPercent: selectWebinarCompletedPercent,
  mobileEnabledPercent: selectMobileEnabledPercent
})

export default connect(mapStateToProps)(BrokerAgentStatsCard)
